import store from './store';

export type { StoreModel } from './model';
export default store;
